/// <reference types="@angular/localize" />

import { APP_BASE_HREF } from "@angular/common";
import { ApplicationConfig, mergeApplicationConfig } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { provideRouter } from "@angular/router";
import { appConfig } from "./app/app.config";

// Repairs //
import { RepairFeedbackFormComponent } from "@app/repairs/repair-form/repair-feedback-form/repair-feedback-form.component";
import { RepairRecallFormComponent } from "@app/repairs/repair-form/repair-recall-form/repair-recall-form.component";
import { RepairHistoryComponent } from "@app/repairs/repair-history/repair-history.component";
import { RepairSummaryComponent } from "@app/repairs/repair-summary/repair-summary.component";
import { RepairDashboardComponent } from "./app/repairs/repair-dashboard/repair-dashboard.component";

// Application //
import { ApplicationComponent } from "@app/application/application.component";
import { AssetSummaryComponent } from "@app/application/asset-summary/asset-summary.component";
// Building Safety //
import { BuildingInformationHistoryComponent } from "@app/building-safety/building-information-history/building-information-history.component";
import { CustomerSafetyHistoryComponent } from "@app/building-safety/customer-safety-history/customer-safety-history.component";
import { DocumentsListComponent } from "@app/documents/documents-list/documents-list.component";
import { PaymentFormComponent } from "@app/payments/payment-form/payment-form.component";
import { PaymentTransactionHistoryComponent } from "@app/payments/payment-transaction-history/payment-transaction-history.component";
import { SignupComponent } from "@app/signup/signup.component";

import { initLayout } from "@app/blocks/ui/layout/subnav-toggle";
import { ApplicationStatusComponent } from "./app/application-status/application-status.component";
import { EventsFeatureComponent } from "./app/events/events-feature/events-feature.component";
import { PaymentRentAndChargesComponent } from "./app/features/payment-rent-and-charges/payment-rent-and-charges";
import { ProfileReviewModalComponent } from "./app/profile/profile-review-modal/profile-review-modal.component";

// Identification //
import { IdentificationComponent } from "@app/identification/identification/identification.component";
import { IDENTIFICATION_ROUTES } from "@app/identification/identification/identification.routes";

initLayout();

document.addEventListener("DOMContentLoaded", () => {
   // Accessing the pathname
   const pathname = window.location.pathname;
   console.log("Pathname:", pathname);

   if (pathname == "/") {
      //BB: these where causing errors on the home page as the components are not in index.html
      //The aspnet core views embed the components they need in the index.html based on its rules.
      //Here we don't know which components are needed so we bootstrap them all and accept that some fail
      //We catch the error so that if the component is not present we just log it and move on
      //also logged in console at another level

      // BB: Updated so that it only bootstraps components whose selector exists in the DOM.
      if (document.querySelector("app-events-feature")) {
         bootstrapApplication(EventsFeatureComponent, appConfig).catch((err) => console.log("EventsFeatureComponent could not bootstrap", err));
      }
      if (document.querySelector("app-profile-review-modal")) {
         bootstrapApplication(ProfileReviewModalComponent, appConfig).catch((err) =>
            console.log("ProfileReviewModalComponent could not bootstrap", err)
         );
      }
      if (document.querySelector("app-application-status")) {
         bootstrapApplication(ApplicationStatusComponent, appConfig).catch((err) =>
            console.log("ApplicationStatusComponent could not bootstrap", err)
         );
      }
      if (document.querySelector("app-payment-rent-and-charges")) {
         bootstrapApplication(PaymentRentAndChargesComponent, appConfig).catch((err) =>
            console.log("PaymentRentAndChargesComponent could not bootstrap", err)
         );
      }
   }

   if (pathname.startsWith("/documents")) {
      bootstrapApplication(DocumentsListComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname == "/repairs" || pathname == "/repairs/") {
      bootstrapApplication(RepairDashboardComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/repairs/repair-feedback")) {
      bootstrapApplication(RepairFeedbackFormComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/repairs/repair-recall")) {
      bootstrapApplication(RepairRecallFormComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/repairs/repair-history")) {
      bootstrapApplication(RepairHistoryComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/repairs/summary")) {
      bootstrapApplication(RepairSummaryComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/application")) {
      bootstrapApplication(AssetSummaryComponent, appConfig).catch((err) => console.error(err));

      bootstrapApplication(ApplicationComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/building-safety/building-information/building-information-history")) {
      bootstrapApplication(BuildingInformationHistoryComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/building-safety/customer-safety-concern/customer-safety-concern-history")) {
      bootstrapApplication(CustomerSafetyHistoryComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/rent-and-charges/make-a-payment") && document.querySelector("app-payment-form")) {
      bootstrapApplication(PaymentFormComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/rent-and-charges/transaction-history")) {
      bootstrapApplication(PaymentTransactionHistoryComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname == "/sign-up/complete-application/") {
      bootstrapApplication(AssetSummaryComponent, appConfig).catch((err) => console.error(err));
      bootstrapApplication(SignupComponent, appConfig).catch((err) => console.error(err));
   }
   if (pathname.startsWith("/identification")) {
      const identificationConfig: ApplicationConfig = mergeApplicationConfig(appConfig, {
         providers: [provideRouter(IDENTIFICATION_ROUTES), { provide: APP_BASE_HREF, useValue: "/identification/" }],
      });
      bootstrapApplication(IdentificationComponent, identificationConfig).catch((err) => console.error(err));
   }
});
